import React, { useState, useEffect } from 'react';
import { Container, Box, Typography, Paper, Alert, CircularProgress } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import BadgeCard from '../components/BadgeCard';
import { verifyBadge } from '../apiBadge';
import Footer from '../../core/Footer';

const VerifyPage = ({ match }) => {
    const [badge, setBadge] = useState(null);
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        const uuid = match.params.id;
        verifyBadge(uuid).then(data => {
            if (!data || data.error) {
                setStatus('not_found');
            } else if (data.revoked) {
                setStatus('revoked');
                setBadge(data);
            } else {
                setStatus('verified');
                setBadge(data);
            }
        });
    }, [match.params.id]);

    return (
        <>
            <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 4, mb: 4 }}>
                <Container maxWidth="lg">
                    <Typography variant="h3" component="h1" sx={{ fontWeight: 700 }}>
                        Badge Verification
                    </Typography>
                </Container>
            </Box>

            <Container maxWidth="sm" sx={{ mb: 6 }}>
                {status === 'loading' && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
                        <CircularProgress sx={{ color: '#003E7E' }} />
                    </Box>
                )}

                {status === 'verified' && badge && (
                    <>
                        <Alert
                            severity="success"
                            icon={<VerifiedIcon />}
                            sx={{
                                mb: 4,
                                py: 2,
                                fontSize: '1.1rem',
                                '& .MuiAlert-icon': { fontSize: 28 }
                            }}
                        >
                            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                Verified Credential
                            </Typography>
                            <Typography variant="body2">
                                This is a valid digital badge issued by the SDS Industry Consortium to{' '}
                                <strong>{badge.recipientName}</strong>.
                            </Typography>
                        </Alert>
                        <BadgeCard badge={badge} />
                    </>
                )}

                {status === 'revoked' && badge && (
                    <Alert
                        severity="error"
                        icon={<ErrorOutlineIcon />}
                        sx={{ py: 2, fontSize: '1.1rem' }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            Credential Revoked
                        </Typography>
                        <Typography variant="body2">
                            This credential was previously issued to{' '}
                            <strong>{badge.recipientName}</strong> but has been revoked
                            by the issuer.
                        </Typography>
                    </Alert>
                )}

                {status === 'not_found' && (
                    <Paper sx={{ p: 4, textAlign: 'center', borderRadius: 3 }}>
                        <ErrorOutlineIcon sx={{ fontSize: 64, color: '#d32f2f', mb: 2 }} />
                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#d32f2f', mb: 1 }}>
                            Credential Not Found
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            No credential was found with this ID. The badge may have been removed or
                            the link may be incorrect.
                        </Typography>
                    </Paper>
                )}
            </Container>

            <Footer />
        </>
    );
};

export default VerifyPage;
